import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
import "./User.css";
import Snackbar from "@mui/material/Snackbar"; // Import Snackbar
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../Responsive/TableResponsive.css";
import { IoSearchOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../src/Config";
import Pagination from "../Component/Pagination";
import useClickOutside from "../useClickOutside";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { HiOutlinePlus } from "react-icons/hi";
import { Link } from "react-router-dom";
import { MdOutlineModeEditOutline } from "react-icons/md";

function MontlyInventoryListReport({ isSidebarExpanded }) {
  const [inventoryReportList, setInventoryReportList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarMessage, setSnackbarMessage] = useState(""); // New state for Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const popupRef = useRef(null);

  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (currentPage, itemsPerPage) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(
        `${API_URL}/api/inventory/monthly_reports`,
        {
          headers: {
            Authorization: authKey,
          },
          params: {
            page: currentPage,
            per_page: itemsPerPage,
          },
        }
      );
      setInventoryReportList(response?.data?.reports);
      setTotalItems(response?.data?.TotalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching department data:", error.message);
      setLoading(false);
    }
  };

  useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

  const handlePaginationChange = (currentPage, itemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(itemsPerPage);
    localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("itemsPerPage", itemsPerPage);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);
  };

  const handleRefresh = () => {
    if (searchInput) {
      console.log("Search input is set:", searchInput);
    } else {
      fetchData(page, itemsPerPage);
    }
    setSearchInput("");
  };

  const closePopups = () => {
    setIsSortPopup(false);
    setIsDeletePopup(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Draft":
        return "gray";
      case "Completed":
        return "green";
      default:
        return "black";
    }
  };

  const handleViewClick = async (monthly_inventory_id) => {
    navigate(`/monthly-inventory-view/${monthly_inventory_id}`);
  };

  const formatDates = (dateString) => {
    if (!dateString || isNaN(Date.parse(dateString))) {
      return "NA";
    }

    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });

    return formatter.format(date);
  };

  const handleButtonClick = (index, event) => {
    setSelectedRowIndex(index === selectedRowIndex ? null : index);
  };

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "", // So that index 1 = January
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    if (!monthNumber || monthNumber < 1 || monthNumber > 12)
      return "Invalid Month";
    return monthNames[monthNumber];
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>All Monthly Inventory Report</PageBackTitle>
              <div className="data-list-heading-content-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={handleSearchInputChange}
                    className="search-bar"
                  />
                  <IoSearchOutline className="search-bar-icon" />
                </div>

                <Link
                  to="/monthly-inventory-report-form"
                  className="data-list-new"
                >
                  <Tooltip title="New User" arrow>
                    <button className="new-button">
                      <HiOutlinePlus className="new-plus-icon" /> New
                    </button>
                  </Tooltip>
                </Link>

                <Tooltip title="Refresh List" arrow>
                  <button className="refresh-button" onClick={handleRefresh}>
                    <TbRefresh className="refresh-icon" />
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>

          <div class="header-separator"></div>
          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : inventoryReportList?.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="">SR. NO.</th>
                        <th>Month</th>
                        <th>Year</th>
                        <th>Description</th>
                        <th className="">STATUS</th>
                        <th className="">ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {inventoryReportList?.length > 0 &&
                        inventoryReportList?.map((reports, index) => (
                          <tr key={reports.id} className="hoverable-row">
                            <td>{reports.serial_no}</td>
                            {/* <td>{formatDates(reports.date || "NA")}</td> */}
                            <td>{getMonthName(reports.month || "NA")}</td>
                            <td>{reports.year || "NA"}</td>
                            <td>{reports.description || "NA"}</td>
                            <td className="">
                              <div
                                // className="pr-request-status"
                                style={{
                                  color: getStatusColor(reports.status),
                                }}
                              >
                                {reports.status || "NA"}
                              </div>
                            </td>

                            <td className="-pop">
                              <div className="" style={{display:"flex", gap:"12px"}}>
                                <button
                                  onClick={() =>
                                    handleViewClick(reports.report_id)
                                  }
                                  className="button-bg"
                                >
                                  View
                                </button>

                                <button
                                  className="edit-data-button"
                                  onClick={(event) =>
                                    handleButtonClick(index, event)
                                  }
                                >
                                  <div className="edit-button">
                                    <MdExpandMore />
                                  </div>
                                </button>
                              </div>
                            </td>
                            {selectedRowIndex === index && (
                              <div
                                className="edit-popup"
                                style={{
                                  position: "absolute",
                                  top: "60.5%",
                                  right: "7%",
                                }}
                                ref={popupRef}
                              >
                                <div className="edit-popup-contant">
                                  <div className="edit-popup-button">
                                    <Link
                                      to={`/edit-monthly-inventory-report/${reports.report_id}`}
                                      className="inquiry-new"
                                    >
                                      <button className="edit-button-inquiry">
                                        <MdOutlineModeEditOutline /> Edit
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No Monthly Inventory List Found</div>
                  </div>
                )}
              </div>
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default MontlyInventoryListReport;
